export default __webpack_public_path__ + "static/exterior_c-5290c072fc8274a7ea6384dc64c4a999.jpg";